import { render } from "./DreamTeamView.vue?vue&type=template&id=38a012f1&scoped=true"
import script from "./DreamTeamView.vue?vue&type=script&lang=js"
export * from "./DreamTeamView.vue?vue&type=script&lang=js"

import "./DreamTeamView.vue?vue&type=style&index=0&id=38a012f1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a012f1"]])

export default __exports__